<template>

    <v-container justify-start>
      <span><router-link :to="{name:'Проекты'}">Проекты</router-link></span> <span>/<b> История счета </b></span>

      <v-divider class="mt-3"></v-divider>
      <!-- balance -->
      <balancebox class="mt-3"/>

      <v-layout row wrap mb-5>
        <div>

        </div>
      </v-layout>
<!-- user transactions -->

      <v-layout row wrap mt-5>
         <v-flex xs12>
          <h2>Транзакции</h2>
         </v-flex>
         <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="transactions"
              hide-actions
              item-key="date">
              <template v-slot:items="props">
                <td>{{ props.item.type }}</td>
                <td>{{ props.item.date }}</td>
                <td class="text-xs-right">{{ props.item.sum }}</td>
                <td>{{ props.item.comment }}</td>
              </template>
            </v-data-table>
        </v-flex>
      </v-layout>

    </v-container>
</template>

<script>
import BalanceBox from "./partials/BalanceBox"

export default {
   components:{
      balancebox:BalanceBox
  },
    created () {
    },
    mounted () {
    },
    computed: {
      transactions () {
         return this.$store.state.account.transactions;
      }
    },
    data() { return {
        headers: [
            { text: 'Тип',
              align: 'left',
              sortable: false,
              value: 'type' },
            { text: 'Дата',
              sortable: false,
              value: 'date' },
            { text: 'Сумма',
              align: 'right',
              sortable: false,
              value: 'sum' },
            { text: 'Комментарии',
              align: 'left',
              sortable: false,
              value: 'comment' }
              ]
    }},
    methods: {
      withdraw() {
        console.log('withdraw');

      }
    }
}
</script>

<style scoped>
    /*stylesheets*/
</style>



// WEBPACK FOOTER //
// AccountHistory.vue?801b26d8